<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row class="d-flex" align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card
            outlined
            width="20vw"
            height="20vh"
            class="d-flex flex-column justify-center align-center"
          >
            <v-card-text class="text-center">
              TO-DO
            </v-card-text>
            <a @click="goBack()">Back</a>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import router from "@/router/index";

export default {
  methods: {
    goBack() {
      router.replace("/");
    }
  }
};
</script>
